import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app/store';
import { TaskExecutionType } from '../api/models/tasks';

export interface TaskExecutionState {
  taskExecutionList: TaskExecutionType[];
  unreadTaskExecutionList: TaskExecutionType[];
}

const initialState: TaskExecutionState = {
  taskExecutionList: [],
  unreadTaskExecutionList: [],
};

export const taskExecutionSlice = createSlice({
  name: 'taskExecutionList',
  initialState,
  reducers: {
    setTaskExecutions: (state, action: PayloadAction<{ taskExecutions: TaskExecutionType[] }>) => {
      state.taskExecutionList = action.payload.taskExecutions;
    },
    addNewTaskExecution: (state, action: PayloadAction<{ taskExecution: TaskExecutionType }>) => {
      state.taskExecutionList.unshift(action.payload.taskExecution);
    },
    setUnreadTaskExecutions: (state, action: PayloadAction<{ taskExecutions: TaskExecutionType[] }>) => {
      state.unreadTaskExecutionList = action.payload.taskExecutions;
    },
    markTaskExecutionAsRead: (state, action: PayloadAction<{ taskExecutionId: string }>) => {
      const taskExecution = state.unreadTaskExecutionList.find(
        (taskExecution) => taskExecution.taskExecutionId === action.payload.taskExecutionId,
      );
      if (taskExecution) {
        state.unreadTaskExecutionList = state.unreadTaskExecutionList.filter(
          (taskExecution) => taskExecution.taskExecutionId !== action.payload.taskExecutionId,
        );
      }
    },
    setInitialTaskExecutionsState: (state) => {
      state.taskExecutionList = [];
      state.unreadTaskExecutionList = [];
    },
  },
});

export const {
  setTaskExecutions,
  addNewTaskExecution,
  setUnreadTaskExecutions,
  markTaskExecutionAsRead,
  setInitialTaskExecutionsState,
} = taskExecutionSlice.actions;

export const selectTaskExecution = (state: RootState) => state.taskExecution;

export default taskExecutionSlice.reducer;
